import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { MotivoTardeService } from '../../../services/MotivoTardeService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'motivo_clave',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. ET-01',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'motivo_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Descripción del motivo de entrega tarde',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const MotivoTardeForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await MotivoTardeService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await MotivoTardeService.guardar(values);
  };

  return (
    <CatalogForm
      title="Motivo de Entrega Tarde"
      subtitle="Causales de demora en la entrega en destino"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/MotivosTarde"
    />
  );
};

export default MotivoTardeForm;
